import { Country } from '@dreryk/address-common-api';

import { commonTranslationKeys, createTranslatedText, FormContextValues, getCurrentLocale } from '@dreryk/react-common';
import { Select, useSelectContext } from '@dreryk/react-components';

import { createCountryFilter } from '../common.utils';

type PartialFormBean = {
   country: Country;
};

export type CountryFieldProps = Pick<FormContextValues<PartialFormBean>, 'register'> & {
   readonly required?: boolean;
};

const getCountryLabel = (item?: Country): string => item?.getName(getCurrentLocale()) ?? '';

const countries = Country.searchAll(getCurrentLocale());
const CountriesList = (): JSX.Element => {
   const { searchText } = useSelectContext();
   const filteredCountries = countries.filter(createCountryFilter(searchText));
   if (!filteredCountries.length) {
      return <Select.NoItems testId={'noCountries'} />;
   }
   return (
      <Select.List items={filteredCountries} keyExtractor={(country: Country) => country.getIsoCode()}>
         {(country: Country) => (
            <Select.Item<Country>
               item={country}
               testId={country.getIsoCode()}
               label={<Select.Highlight node={createTranslatedText(getCountryLabel(country))} />}
            />
         )}
      </Select.List>
   );
};

export const CountryField = (props: CountryFieldProps): JSX.Element => {
   return (
      <Select<Country>
         testId={'country'}
         triggerLabelExtractor={getCountryLabel}
         controller={props.register('country', { required: props.required })}
         label={commonTranslationKeys.addressData.country}
         maxHeight={190}
         searchInputEnabled
      >
         <CountriesList />
      </Select>
   );
};
